const ButtonStop = () => {
  return (
    <svg
      width="40"
      height="40"
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="40" height="40" rx="20" fill="white" />
      <rect x="13" y="13" width="14" height="14" rx="3" fill="#FD8533" />
    </svg>
  );
};

export default ButtonStop;
